import {Component, OnInit} from '@angular/core';
import {ModalComponent} from 'app/core/modal.component';
import {MessageStateType} from '../../../../../../../chat-sdk/src/entities/messages/messageState';
import {LookinChatSDK} from '../../../../../../../chat-sdk/src';
import {Message} from '../../../../../../../chat-sdk/src/entities/messages/message';

@Component({
  selector: 'app-chat-action-modal',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class ChatActionModalComponent extends ModalComponent implements OnInit {

  message: Message = null;

  // @todo chat redo to get from chat sdk
  reactions = [
    'beaming-face-with-smiling-eyes',
    'face-exhaling',
    'face-with-open-mouth',
    'face-with-tears-of-joy',
    'loudly-crying-face',
    'pouting-face',
    'smiling-face-with-heart-eyes',
    'smiling-face-with-sunglasses',
    'winking-face-with-tongue'
  ];

  // @todo chat why not using default select modal ???
  ngOnInit() {
  }

  closeModal(action: MessageStateType | 'reply' | 'pin' = null, reaction: string = null) {
    return super.closeModal({action, reaction});
  }

  protected readonly close = close;
  protected readonly LookinChatSDK = LookinChatSDK;
}
